export default [
  {
    path: "/appointments-calendar",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/appointments-calendar",
        name: "appointments-calendar",
        component: () => import("./AppointmentsCalendar.vue"),
      },
    ],
  },
];
